export default {"src":"/_next/static/media/report-new-disabled.335139b2.svg","height":32,"width":32};